import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DAY_TOMORROW } from '@whitbread-eos/api';
import { add, differenceInDays, format } from 'date-fns';
import { isDateValid } from '../../validators';
import analytics from './analytics';
var updateHotelDisplayPageAnalytics = _ref => {
  var _promoActions$promoSt, _promoActions$promoSt2, _dataHotelAvailabilit, _dataHotelAvailabilit2, _dataHotelAvailabilit3, _promoDetails$rateTag, _format, _format2, _Object$keys, _dataHotelAvailabilit4, _dataHotelAvailabilit5, _searchData$roomType;
  var multiSearchParams = _ref.multiSearchParams,
    hotelName = _ref.hotelName,
    hotelId = _ref.hotelId,
    hotelLabel = _ref.hotelLabel,
    hotelAvailability = _ref.hotelAvailability,
    hotelFacilityIcons = _ref.hotelFacilityIcons,
    isMetaArrivalDayKeywordFlagEnabled = _ref.isMetaArrivalDayKeywordFlagEnabled,
    dataHotelAvailability = _ref.dataHotelAvailability,
    promoActions = _ref.promoActions,
    isPromoBoxVisible = _ref.isPromoBoxVisible;
  var urlPromo = multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.PROMOID;
  var bannerPromo = promoActions === null || promoActions === void 0 || (_promoActions$promoSt = promoActions.promoState) === null || _promoActions$promoSt === void 0 ? void 0 : _promoActions$promoSt.code;
  var promoType = promoActions === null || promoActions === void 0 || (_promoActions$promoSt2 = promoActions.promoState) === null || _promoActions$promoSt2 === void 0 ? void 0 : _promoActions$promoSt2.type;
  var PromoId = urlPromo ? urlPromo === bannerPromo ? urlPromo : '' : bannerPromo !== null && bannerPromo !== void 0 ? bannerPromo : '';
  var roomRatesList = (_dataHotelAvailabilit = dataHotelAvailability === null || dataHotelAvailability === void 0 || (_dataHotelAvailabilit2 = dataHotelAvailability.hotelAvailability) === null || _dataHotelAvailabilit2 === void 0 ? void 0 : _dataHotelAvailabilit2.roomRates) !== null && _dataHotelAvailabilit !== void 0 ? _dataHotelAvailabilit : [];
  var matchedRate = roomRatesList === null || roomRatesList === void 0 ? void 0 : roomRatesList.find(rate => rate.promotionCode === PromoId);
  var promoDetails = dataHotelAvailability === null || dataHotelAvailability === void 0 || (_dataHotelAvailabilit3 = dataHotelAvailability.ratesInformation) === null || _dataHotelAvailabilit3 === void 0 || (_dataHotelAvailabilit3 = _dataHotelAvailabilit3.rateClassifications) === null || _dataHotelAvailabilit3 === void 0 ? void 0 : _dataHotelAvailabilit3.find(item => (item === null || item === void 0 ? void 0 : item.rateClassification) === (matchedRate === null || matchedRate === void 0 ? void 0 : matchedRate.ratePlanCode));
  var rateName = promoDetails !== null && promoDetails !== void 0 && promoDetails.rateTags ? "".concat(promoDetails === null || promoDetails === void 0 || (_promoDetails$rateTag = promoDetails.rateTags) === null || _promoDetails$rateTag === void 0 ? void 0 : _promoDetails$rateTag[0], " ").concat(promoDetails === null || promoDetails === void 0 ? void 0 : promoDetails.rateName) : '';
  var eligibility = roomRatesList === null || roomRatesList === void 0 ? void 0 : roomRatesList.some(rate => (rate === null || rate === void 0 ? void 0 : rate.promotionCode) === PromoId);
  var isStartDateValid = isDateValid(Number(multiSearchParams.ARRdd), Number(multiSearchParams.ARRmm), Number(multiSearchParams.ARRyyyy));
  var addValidDate = arrivalDay => {
    if (isMetaArrivalDayKeywordFlagEnabled && typeof arrivalDay !== 'undefined' && (arrivalDay === null || arrivalDay === void 0 ? void 0 : arrivalDay.toLowerCase()) === DAY_TOMORROW) {
      return add(new Date(), {
        days: 1
      });
    } else {
      return new Date();
    }
  };
  var startDate = isStartDateValid ? new Date(Number(multiSearchParams.ARRyyyy), Number(multiSearchParams.ARRmm) - 1, Number(multiSearchParams.ARRdd)) : addValidDate(multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.ARRdd);
  var endDate = add(startDate, {
    days: Number(multiSearchParams.NIGHTS)
  });
  var searchWeekdayFrom = (_format = format(startDate, 'eee')) === null || _format === void 0 ? void 0 : _format.toLowerCase();
  var searchWeekdayTo = (_format2 = format(endDate, 'eee')) === null || _format2 === void 0 ? void 0 : _format2.toLowerCase();
  var searchData = (_Object$keys = Object.keys(multiSearchParams)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.reduce((acc, currentValue) => {
    if (currentValue.includes('CHILD')) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        numberOfChildren: acc.numberOfChildren + Number(multiSearchParams[currentValue])
      });
    }
    if (currentValue.includes('ADULT')) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        numberOfAdults: acc.numberOfAdults + Number(multiSearchParams[currentValue])
      });
    }
    if (currentValue.includes('INTTYP')) {
      var _acc$roomType;
      var value = acc.roomType.length ? "".concat(acc.roomType, ":").concat(multiSearchParams[currentValue]) : multiSearchParams[currentValue];
      return _objectSpread(_objectSpread({}, acc), {}, {
        roomType: !((_acc$roomType = acc.roomType) !== null && _acc$roomType !== void 0 && _acc$roomType.includes(multiSearchParams[currentValue])) ? value : acc.roomType
      });
    }
    return _objectSpread({}, acc);
  }, {
    numberOfAdults: 0,
    numberOfChildren: 0,
    roomType: ''
  });
  var roomAvailability = (_dataHotelAvailabilit4 = dataHotelAvailability === null || dataHotelAvailability === void 0 || (_dataHotelAvailabilit5 = dataHotelAvailability.hotelAvailability) === null || _dataHotelAvailabilit5 === void 0 || (_dataHotelAvailabilit5 = _dataHotelAvailabilit5.roomRates[0]) === null || _dataHotelAvailabilit5 === void 0 || (_dataHotelAvailabilit5 = _dataHotelAvailabilit5.roomTypes[0]) === null || _dataHotelAvailabilit5 === void 0 || (_dataHotelAvailabilit5 = _dataHotelAvailabilit5.rooms) === null || _dataHotelAvailabilit5 === void 0 || (_dataHotelAvailabilit5 = _dataHotelAvailabilit5.map(room => {
    var _room$roomPriceBreakd;
    return {
      roomsAvailable: room === null || room === void 0 ? void 0 : room.numberOfRoomsAvailable,
      price: room === null || room === void 0 || (_room$roomPriceBreakd = room.roomPriceBreakdown) === null || _room$roomPriceBreakd === void 0 ? void 0 : _room$roomPriceBreakd.totalNetAmount
    };
  })) === null || _dataHotelAvailabilit5 === void 0 ? void 0 : _dataHotelAvailabilit5.sort((a, b) => a.price - b.price)) !== null && _dataHotelAvailabilit4 !== void 0 ? _dataHotelAvailabilit4 : [];
  var rdata = roomAvailability === null || roomAvailability === void 0 ? void 0 : roomAvailability.map(x => btoa(String(x.roomsAvailable).split('').reverse().join('')).replaceAll('=', ''));
  var promotions = {
    promoName: rateName,
    promoCode: PromoId,
    eligibility: eligibility,
    promoJourney: eligibility,
    promoBoxVisible: isPromoBoxVisible
  };
  var uniquePromotions = {
    promoName: promoType,
    promoCode: PromoId,
    promoBoxVisible: isPromoBoxVisible
  };
  var promotionsAnalytics = promoType === 'UNIQUE' ? uniquePromotions : promotions;
  analytics.update({
    analyticsDataSearchResult: {
      searchCheckInDate: format(startDate, 'dd/MM/yyyy'),
      searchCheckOutDate: format(endDate, 'dd/MM/yyyy'),
      searchDaysToCheckIn: differenceInDays(new Date(startDate), new Date()),
      searchNumberOfAdults: searchData.numberOfAdults,
      searchNumberOfChildren: searchData.numberOfChildren,
      searchNumberOfGuests: searchData.numberOfAdults + searchData.numberOfChildren,
      searchNumberOfNights: Number(multiSearchParams.NIGHTS),
      searchNumberOfRooms: Number(multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.ROOMS),
      searchResults: 1,
      searchResultsDisplayed: [{
        bookingSystem: 'Opera',
        hotelAvailability: hotelAvailability !== null && hotelAvailability !== void 0 ? hotelAvailability : '',
        hotelCode: hotelId.toLowerCase(),
        hotelDistance: 0,
        hotelFacilityIcons: hotelFacilityIcons !== null && hotelFacilityIcons !== void 0 ? hotelFacilityIcons : [],
        hotelLabel: hotelLabel !== null && hotelLabel !== void 0 ? hotelLabel : ['no label'],
        imageLabel: '',
        priceFrom: '',
        voucherCode: ''
      }],
      searchRoomType: (_searchData$roomType = searchData.roomType) === null || _searchData$roomType === void 0 ? void 0 : _searchData$roomType.toLowerCase(),
      searchTerm: hotelName,
      searchType: 'list view',
      searchWeekdayFrom,
      searchWeekdayFromTo: "".concat(searchWeekdayFrom, "-").concat(searchWeekdayTo),
      searchWeekdayTo,
      mapLoaded: false
    },
    discountTags: rateName,
    promo: promotionsAnalytics
  });
  analytics.updateEncodedAnalytics(rdata);
};
export default updateHotelDisplayPageAnalytics;